import a from "lodash/isFinite";
import { getProp as f } from "./utils.js";
const c = new Intl.Collator("en", { numeric: !0, sensitivity: "base" });
function d(r, t) {
  return r == null ? -1 : t == null ? 1 : a(r) && a(t) ? r - t : c.compare(r, t);
}
function o(r) {
  switch (typeof r) {
    case "boolean":
      return !1;
    case "string":
      return /^\d+$/.test(r) && r.length === 13;
    case "number":
      return Number.isNaN(r) || !Number.isFinite(r) ? !1 : /^\d+$/.test(r) && String(r).length === 13;
    default:
      return !1;
  }
}
function m(r, t, e) {
  let n = f(r, e.property), i = f(t, e.property);
  if (e.sortBy)
    switch (typeof e.sortBy) {
      case "string":
        n = f(r, e.sortBy), i = f(t, e.sortBy);
        break;
      case "function":
        n = e.sortBy(r), i = e.sortBy(t);
        break;
    }
  else e.formatter && (o(n) || (n = e.formatter(r, e)), o(i) || (i = e.formatter(t, e)));
  const s = {
    ascending: 1,
    descending: -1
  }[e.order];
  return d(n, i) * s;
}
function p(r) {
  return r.sortMethod ? (t, e) => r.sortMethod(t, e, r.order) : (t, e) => m(t, e, r);
}
function u(r, t, e = [], n) {
  if (n && n.sortChildren && Array.isArray(r[n.childKey])) {
    const i = [...r[n.childKey]].sort((s, y) => t(s, y, [...e, r])).map((s) => u(s, t, [...e, r, s], n));
    return { ...r, [n.childKey]: i };
  }
  return r;
}
function N({ rows: r, sortConfig: t, options: e }) {
  if (t.column) {
    if (t.column.order === "none")
      return [...r];
    const n = p(t.column);
    return e.groupKey ? r.map((i) => u(i, n, [], e)) : r.sort((i, s) => n(i, s)).map((i) => u(i, n, [], e));
  }
  return r;
}
export {
  m as compare,
  d as comparer,
  o as isTimestamp,
  N as sortRows
};
//# sourceMappingURL=sort.js.map
